import { useRef } from 'react';
import { ErrorMessage, SuccessMessage, useMessageService } from 'framework/ui/Message';
import usePositionFillRequestsService from '../usePositionFillRequestsService';

const useCancelPositionFillRequestAction = (onSuccess: () => void) => {
  const { cancelPositionFillRequest } = usePositionFillRequestsService();
  const { addMessage } = useMessageService();
  const pendingRequestIds = useRef(new Set<string>());

  const cancel = async (positionFillRequestId: string) => {
    if (pendingRequestIds.current.has(positionFillRequestId)) return;

    pendingRequestIds.current.add(positionFillRequestId);

    try {
      await cancelPositionFillRequest(positionFillRequestId);
      addMessage(new SuccessMessage('Position fill request has been cancelled.'));
      onSuccess();
    } catch {
      addMessage(new ErrorMessage('Unable to cancel the position fill request.'));
    } finally {
      pendingRequestIds.current.delete(positionFillRequestId);
    }
  };

  return { cancel };
};

export default useCancelPositionFillRequestAction;
